import { ElasticSearchService, ESExtras } from "@common/api-server";
import { EsFirestoreBase } from "@common/helpers/es-firestore-base";

import { Injectable, Optional } from '@angular/core';
import { collectionData, Firestore, query, QueryConstraint, where } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { UserModel } from '../models/user.model';

const ES_EXTRA: ESExtras = {
  name: { type: 'text' },
  'country.name': { type: 'text' },
}
const ES_SOURCE = null; //['status']
const DATE_PROPERTIES = undefined; //['createdAt', 'updatedAt'];


// console.log(db);

export type Model = UserModel;
const collectionName = 'users';

@Injectable({
  providedIn: 'root'
})
export class UserDbService extends EsFirestoreBase<Model>{
  override collectionName = collectionName;
  constructor(
    @Optional() protected override firestore: Firestore,
    protected override es: ElasticSearchService,

  ) {
    super(firestore, es, collectionName, ES_EXTRA, ES_SOURCE, DATE_PROPERTIES);
  }


  adminUsers$(allAdministrative = false) {
    let _where: QueryConstraint[] = [];
    // for (const key in options){
    //   _where.push(where(key, '==', options[key]));
    // }
    // _where.push((where('roles', 'array-contains-any', [UserModel.AdminRole])))
    const roles = allAdministrative ? UserModel.AdministrativeRoles : [UserModel.AdminRole];
    _where.push((where('roles', 'array-contains-any', roles)))
    const _query = query(this.collection, ..._where);
    return collectionData(_query, { idField: 'id' }) as Observable<Array<UserModel>>
  }

  // public apiSearch(queryOptions:any): Observable<any> {
  //   const {paginator, sort, filters, serialize, options, source} = queryOptions;
  //   //source tomaremos, los defaults si estan vacios ['name', 'country']

  //   const body = this.es.mtToBody(paginator, sort, filters, this.esExtras, (source ?? this.esSource));

  //   let path = `api/search`;
  //   return httpsCallableData(this.functions, path, { timeout: 60_000 })({index:collectionName, body})
  //     .pipe(
  //       map((result:any)=>{
  //         let response = result;
  //         let data = response.hits.hits.map((item:any) =>{
  //             const id = item._id;
  //             //Serializamos por si en la consulta hay datos que transformar, lo hará cada responsable
  //             let source = serialize ? serialize(item._source): this.esNormalize(item._source);
  //             return {id, ...source};
  //           })
  //         let _meta = {
  //           count:response.hits.total.value,
  //           body:{}
  //         }
  //         if(options?.body) _meta.body = body;
  //         return {data,_meta}
  //       })
  //     );
  // }
  //Serializar Firestore
  // setFirestoreConverter(){
  //   this.genericConverter.fromFirestore = (
  //     snapshot: QueryDocumentSnapshot,
  //     options: SnapshotOptions
  //   ): OrderModel => {
  //     const data = snapshot.data(options)!;
  //     data.status = "jos"
  //     data.createdAt = toDate(data.createdAt);
  //     data.updatedAt = toDate(data.updatedAt);
  //     console.log("y llama este ....")
  //     return data as OrderModel;
  //   }
  // }
  // Serializar Elastic Search
  // esNormalize = (item:any) => {
  //   item.createdAt = item.createdAt ? new Date(item.createdAt._seconds * 1000) : null;
  //   return item;
  // };

}
